import React from 'react'
import styled from 'styled-components'
import { Star, StarBorder, StarHalf } from '@mui/icons-material';

interface IStarIconProps {
  isEmpty?: boolean;
  isHalf?: boolean;
}

const Container = styled.div`
  .MuiSvgIcon-root {
    color: #fab01c
  }
`;

function StarIcon({ isHalf = false, isEmpty = false }: IStarIconProps) {
  return (
    <Container>
      {isEmpty ? <StarBorder /> : isHalf ? <StarHalf /> : <Star />}
    </Container>
  )
}

export { StarIcon }